const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class BookingCommandConnector {

  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async createBooking(options) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/bookings`,
        method: 'POST',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateBooking(bookingId, body) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/bookings/${bookingId}/request`,
        method: 'PUT',
        data: {
          ...body,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async confirmBookingUpdate(bookingId) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/bookings/${bookingId}/confirm`,
        method: 'PUT',
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async requestBooking(options) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/bookings/request`,
        method: 'POST',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async requestBookingV2(options) {
    try {
      const request = {
        url: '/v2/bookings/request',
        method: 'POST',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async confirmBooking({ bookingId }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/bookings/${bookingId}/confirm`,
        method: 'POST',
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async cancelBooking({ bookingId }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/bookings/${bookingId}/cancel`,
        method: 'POST',
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }

}

module.exports = {
  BookingCommandConnector,
};
